// extracted by mini-css-extract-plugin
module.exports = {"base":"Circle_base__3IcYp"};